import styled from 'styled-components';
import { ProductVersionTag } from 'components/product/product.styles';
import { Sup } from 'shared/styles/components';
import { Blog } from './blog.types';

const VersionedHeading = styled.span`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

/** Keep the complete plain-text title in data for metadata and accessible links. */
export default function BlogHeading({ blog, showVersionTag = true }: { blog: Blog; showVersionTag?: boolean }) {
  const version = showVersionTag && blog.version && blog.title.endsWith(` ${blog.version}`) ? blog.version : undefined;
  const title = version ? blog.title.slice(0, -(version.length + 1)) : blog.title;

  const heading = (
    <>
      {title.split('+').map((part, index) => (
        <span key={index}>{index > 0 && <Sup>+</Sup>}{part}</span>
      ))}
    </>
  );

  return version ? (
    <VersionedHeading>
      <span>{heading}</span>{' '}
      <ProductVersionTag><span>{version}</span></ProductVersionTag>
    </VersionedHeading>
  ) : heading;
}
